import React, { FC, useEffect, useState } from 'react';
import { AdminGroupEventsDto } from '../../../common/interfaces/group.interface';
import { createNotification } from '../../../utilities/helper/notification.helper';
import { MESSAGE_TYPE } from '../../../common/constants/common.constants';
import { getGroupEventsSummary } from '../../../api/group.api';
import { Box, CircularProgress, Tab, Tabs, Typography, useTheme } from '@mui/material';
import { ReactComponent as ListEmptyStateIcon } from '../../../assets/list-empty-state-icon.svg';
import { centeredContainerStyle } from '../../KindergartenDetails/components/LocationsAndGroupsTab/LocationsAndGroupsTab.styles';
import EventDetails from '../../KindergartenDetails/components/EventTab/EventDetails/EventDetails';
import { ActionMode } from '../../../common/enums/common.enum';
import { EventIcon } from '../../../components/EventSelector/ParentEventSelector.styles';

const STORAGE = process.env.REACT_APP_STORAGE as string;

const GroupEventsTab: FC<{ groupId: string; isGroupActive: boolean }> = ({ groupId, isGroupActive }) => {
  const [groupEvents, setGroupEvents] = useState<AdminGroupEventsDto[]>([]);
  const [loading, setLoading] = useState<boolean>();
  const [activeTab, setActiveTab] = useState<string>();

  useEffect(() => {
    loadGroupEvents();
  }, [groupId]);

  const loadGroupEvents = async () => {
    try {
      setLoading(true);
      const response = await getGroupEventsSummary(groupId);
      if (response.results) {
        setGroupEvents(response.results);
        if (response.results.length) {
          setActiveTab(response.results[0]?.id);
        }
      }
    } catch (error) {
      createNotification(MESSAGE_TYPE.ERROR, 'Failed to load group events');
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };

  if (loading) {
    <Box sx={centeredContainerStyle}>
      <CircularProgress />
    </Box>;
  }

  return (
    <Box>
      {groupEvents.length ? (
        <Box sx={{ mt: 4, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ whiteSpace: 'nowrap', mb: 3, maxWidth: 'calc(100vw - 400px)' }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              textColor="primary"
              indicatorColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              sx={{
                '& .MuiTab-root': { fontSize: 16, fontWeight: '600', textTransform: 'none' }
              }}
            >
              {groupEvents.map(({ title, id, icon }) => {
                const isSelected = activeTab === id;

                return (
                  <Tab
                    key={id}
                    label={
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        {icon && <EventIcon src={`${STORAGE}${icon}`} alt={title} selected={isSelected} />}
                        <span>{title}</span>
                      </Box>
                    }
                    value={id}
                  />
                );
              })}
            </Tabs>
          </Box>
          {activeTab && <EventDetails eventId={activeTab} groupId={groupId} mode={ActionMode.EDIT} />}
        </Box>
      ) : (
        !loading && (
          <Box sx={centeredContainerStyle}>
            <ListEmptyStateIcon style={{ fontSize: 40, color: 'text.secondary' }} />
            <Typography sx={{ fontWeight: 'bold' }}>No event configuration created yet</Typography>
          </Box>
        )
      )}
    </Box>
  );
};

export default GroupEventsTab;
